import script from "./MyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPage.vue?vue&type=script&setup=true&lang=ts"

import "./MyPage.vue?vue&type=style&index=0&id=49507072&scoped=true&lang=less"
import "./MyPage.vue?vue&type=style&index=1&id=49507072&lang=css"

import exportComponent from "/data/liulv-h5/bj-International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49507072"]])

export default __exports__